import { useState } from "react";
import axios from "axios";
const API = "https://danielcantos.net/api";
export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const handleLogin = async () => {
    if (!username || !password) return;
    setLoading(true);
    setError("");
    try {
      const form = new FormData();
      form.append("username", username);
      form.append("password", password);
      const res = await axios.post(`${API}/auth/token`, form);
      localStorage.setItem("token", res.data.access_token);
      localStorage.setItem("username", username);
      onLogin(res.data.access_token, username);
    } catch {
      setError("Usuario o contrasena incorrectos");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div style={{minHeight:"100vh",background:"#0f172a",display:"flex",alignItems:"center",justifyContent:"center"}}>
      <div style={{background:"#1e293b",borderRadius:"16px",padding:"40px",width:"340px",boxShadow:"0 8px 32px rgba(0,0,0,0.4)"}}>
        <div style={{textAlign:"center",marginBottom:"32px"}}>
          <div style={{fontSize:"48px"}}>🤖</div>
          <h1 style={{color:"white",fontSize:"22px",margin:0}}>AI Project Manager</h1>
          <p style={{color:"#94a3b8",fontSize:"13px"}}>Inicia sesion para continuar</p>
        </div>
        <div style={{marginBottom:"16px"}}>
          <label style={{color:"#94a3b8",fontSize:"12px",display:"block",marginBottom:"6px"}}>USUARIO</label>
          <input value={username} onChange={e=>setUsername(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleLogin()} placeholder="Tu usuario" style={{width:"100%",padding:"10px 14px",background:"#0f172a",border:"1px solid #334155",borderRadius:"8px",color:"white",fontSize:"14px",outline:"none",boxSizing:"border-box"}}/>
        </div>
        <div style={{marginBottom:"24px"}}>
          <label style={{color:"#94a3b8",fontSize:"12px",display:"block",marginBottom:"6px"}}>CONTRASENA</label>
          <input type="password" value={password} onChange={e=>setPassword(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleLogin()} placeholder="Tu contrasena" style={{width:"100%",padding:"10px 14px",background:"#0f172a",border:"1px solid #334155",borderRadius:"8px",color:"white",fontSize:"14px",outline:"none",boxSizing:"border-box"}}/>
        </div>
        {error&&<div style={{color:"#f87171",fontSize:"13px",marginBottom:"16px",textAlign:"center"}}>{error}</div>}
        <button onClick={handleLogin} disabled={loading} style={{width:"100%",padding:"12px",background:loading?"#475569":"#3b82f6",color:"white",border:"none",borderRadius:"8px",cursor:loading?"not-allowed":"pointer",fontWeight:700,fontSize:"15px"}}>
          {loading?"Ingresando...":"Ingresar"}
        </button>
      </div>
    </div>
  );
}
